import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ToastService } from '../../services/toast.service';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {  State, City } from 'country-state-city';
import countryToCurrency from 'country-to-currency';
import { DynamicFieldComponent } from './dynamic-field/dynamic-field.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-form-setup',
  imports: [
    CommonModule,
    DynamicFieldComponent,
    NgbModule
  ],
  templateUrl: './form-setup.component.html',
  styleUrl: './form-setup.component.scss',

})
export class FormSetupComponent implements OnInit, OnChanges {
  @Input() FromJson: any;
  formConfig: any;
  @Input() submitForm: boolean = false;
  @Output() formCheck = new EventEmitter<boolean>()
  @Output() formEmitted = new EventEmitter<{ id: string; value: any }>();
  @Input() id: string = '';
  @Input() callItems : boolean = false
  myForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private cdr: ChangeDetectorRef
  ) {
    this.myForm = this.fb.group({});
  }




  ngOnInit(): void {
    this.formConfig = this.FromJson;

    // initialize tabs
    this.formConfig?.forEach((f: any) => {
      if (f.type === 'tabs' && !f.active && f.tabs?.length) {
        f.active = f.tabs[0].id;
      }
      if (f.type === 'groups') {
        if (f.type === 'radio' && f.existingValue === 'N') {
          this.formConfig = this.formConfig.map((item: any) =>
            item.type === 'checkbox' ? { ...item, disabled: true } : item
          );
        }
      }
    });

    setTimeout(() => {
      this.checkFormValidity();
    }, 0);
  }

ngOnChanges(changes: SimpleChanges): void {
  if (changes['FromJson'] && changes['FromJson'].currentValue) {
    this.formConfig = changes['FromJson'].currentValue;
    setTimeout(() => {
      this.checkFormValidity();
    }, 0);
  }

  if (changes['submitForm'] && changes['submitForm'].currentValue === true) {
    const isValid = this.checkFormValidity();
    this.submitForm = false;

    if (!isValid) {
      // 🔄 recursively mark missing required fields
      this.markRequired(this.formConfig);
      this.formCheck.emit(false);
      return;
    } else {
      this.formEmitted.emit({
        id: this.id,
        value: this.myForm.value
      });
      this.formCheck.emit(true);
    }
  }
}

/**
 * Recursively walk through config and mark required fields
 */
private markRequired(items: any[]): void {
  if (!items) return;

  items.forEach((item: any) => {
    if (item.keyRequired) {
      item.checkValidation = true;
    }

    // if it's a group, check its children
    if (item.type === 'group' && Array.isArray(item.children)) {
      this.markRequired(item.children);
    }

    // if it's a tabs container, check inside its tabs
    if (item.type === 'tabs' && Array.isArray(item.tabs)) {
      item.tabs.forEach((tab: any) => {
        if (Array.isArray(tab.children)) {
          this.markRequired(tab.children);
        }
      });
    }
  });
}



reloadSelectItems(id: any): void {
  const updateField = (items: any[]): boolean => {
    if (!items) return false;

    for (let item of items) {
      // ✅ Match found → reload options
      if (item.id === id && item.type === 'select-dropdown') {
        let apiURL = environment.apiURL;

        if (item.api?.url) {
          let params = new HttpParams();
          if (item.api.params) {
            Object.entries(item.api.params).forEach(([key, val]) => {
              params = params.set(key, val as string);
            });
          }

          this.http.get<any>(apiURL + item.api.url, { params }).subscribe({
            next: (res: any) => {
              item.options = {
                list:
                  res?.Data?.map((d: any) => ({
                    id: d._id,
                    name: d.name,
                  })) ?? [],
              };
              // console.log(`🔄 Options reloaded for ${id}:`, item.options);
            },
            error: (err) => {
              console.error(`❌ Failed to reload options for ${id}`, err);
              item.options = { list: [] }; // fallback
            },
          });
        }
        return true; // ✅ found → stop further search
      }

      // 🔁 Dive into groups
      if (item.type === 'group' && Array.isArray(item.children)) {
        if (updateField(item.children)) return true;
      }

      // 🔁 Dive into tabs
      if (item.type === 'tabs' && Array.isArray(item.tabs)) {
        for (let tab of item.tabs) {
          if (Array.isArray(tab.children)) {
            if (updateField(tab.children)) return true;
          }
        }
      }
    }
    return false;
  };

  updateField(this.formConfig);
}



  checkRequired: boolean = false;
  requiredIds: string[] = [];

  catchRequiredList(payload: { id: string; required: boolean }) {
    if (payload.required) {
      if (!this.requiredIds.includes(payload.id)) {
        this.requiredIds.push(payload.id);
      }
    } else {
      this.requiredIds = this.requiredIds.filter(id => id !== payload.id);
    }
    this.checkFormValidity();
  }

  getRequiredFieldList(): string[] {
    const ids = new Set<string>(this.requiredIds);
    const extract = (items: any[]) => {
      if (!items) return;
      items.forEach((item: any) => {
        if ((item.keyRequired || item.required) && item.id) {
          ids.add(item.id);
        }
        if (item.type === 'group' && Array.isArray(item.children)) {
          extract(item.children);
        }
        if (item.type === 'tabs' && Array.isArray(item.tabs)) {
          item.tabs.forEach((tab: any) => extract(tab.children));
        }
      });
    };
    extract(this.formConfig);
    return Array.from(ids);
  }

  checkFormValidity(): boolean {
    const requiredList = this.getRequiredFieldList();

    const missing = requiredList.filter(id => {
      const ctrl = this.myForm.get(id);
      if (!ctrl) {
        let existingVal: any = undefined;
        const findVal = (items: any[]) => {
          if (!items) return;
          for (const item of items) {
            if (item.id === id) {
              existingVal = item.existingValue;
              return;
            }
            if (item.type === 'group' && Array.isArray(item.children)) findVal(item.children);
            if (item.type === 'tabs' && Array.isArray(item.tabs)) item.tabs.forEach((t: any) => findVal(t.children));
          }
        };
        findVal(this.formConfig);
        return existingVal === undefined || existingVal === null || String(existingVal).trim() === '';
      }
      const val = ctrl.value;
      return val === undefined || val === null || String(val).trim() === '';
    });

    if (missing.length > 0) {
      this.formCheck.emit(false);
      return false;
    }

    // Validate pattern regex across all fields
    let hasPatternError = false;
    const checkPatterns = (items: any[]) => {
      if (!items || hasPatternError) return;
      for (const item of items) {
        if (item.pattern && item.id) {
          const ctrl = this.myForm.get(item.id);
          const val = ctrl ? ctrl.value : item.existingValue;
          if (val !== undefined && val !== null && String(val).trim() !== '') {
            try {
              const regex = new RegExp(item.pattern);
              if (!regex.test(String(val).trim())) {
                hasPatternError = true;
                return;
              }
            } catch (e) {
              console.error('Invalid pattern regex', e);
            }
          }
        }
        if (item.type === 'group' && Array.isArray(item.children)) checkPatterns(item.children);
        if (item.type === 'tabs' && Array.isArray(item.tabs)) item.tabs.forEach((t: any) => checkPatterns(t.children));
      }
    };
    checkPatterns(this.formConfig);

    const isValid = !hasPatternError;
    this.formCheck.emit(isValid);
    return isValid;
  }
  
  private updateFieldOptions(config: any[], fieldId: string, options: any[]): any[] {
    config.forEach(node => {  
      // Case 1: tabs container
      if (node.tabs) {
        node.tabs.forEach((tab: any) => {
          this.updateFieldOptions(tab.children || [], fieldId, options);
        });
      }

      // Case 2: children container
      if (node.children) {
        this.updateFieldOptions(node.children, fieldId, options);
      }

      // Case 3: field match
      if (node.id === fieldId) {
        //console.log(`✅ Updating ${fieldId} with options`, options);
        node.options = { list: options };   // 🔄 direct mutation
      }
    });

    return config; // same reference
  }

  private updateFieldValue(config: any[], fieldId: string, value: any): any[] {
    config.forEach(node => {
      if (node.tabs) {
        node.tabs.forEach((tab: any) => {
          this.updateFieldValue(tab.children || [], fieldId, value);
        });
      }

      if (node.children) {
        this.updateFieldValue(node.children, fieldId, value);
      }

      if (node.id === fieldId) {
        //console.log(`✅ Updating ${fieldId} with value`, value);
        node.existingValue = value;   // 🔄 direct mutation
      }
    });

    return config; // same reference
  }


  countrycode:string = ''
  CollectEmit(payload: { id: string; value: string; name?: string }) {
    // console.log('Received:', payload);

    if (!this.myForm.contains(payload.id)) {
      this.myForm.addControl(
        payload.id,
        this.fb.control(payload.name ?? payload.value)
      );
    } else {
      this.myForm.get(payload.id)?.setValue(payload.value);
    }

    if (payload.id === 'country') {
      console.log(payload);
      
      const states = State.getStatesOfCountry(payload.value).map(s => ({
        id: s.isoCode,
        name: s.name,
      }));
      this.countrycode = payload.value;

      const currency = (countryToCurrency as Record<string, string>)[payload.value] || '';

      // 🔄 Update nested structure for state + currency
      this.updateFieldOptions(this.formConfig, 'state', states);
      this.updateFieldValue(this.formConfig, 'currency', currency);

    }

    if (payload.id === 'state') {
      const countryCode = this.countrycode;
      const stateCode = payload.value;

      const cities = City.getCitiesOfState(countryCode, stateCode).map(c => ({
        id: c.name,
        name: c.name,
      }));

      // 🔄 Update nested structure for city
      this.formConfig = this.updateFieldOptions(this.formConfig, 'city', cities);
      
    }

    this.checkFormValidity();
    console.log('Form Value:', this.myForm.value);
  }

  CollectCheckbox(payload: { id: string; values: string }) {
    //console.log('Received Checkbox:', payload);

    if (!this.myForm.contains(payload.id)) {
      this.myForm.addControl(payload.id, this.fb.control(payload.values));
    } else {
      this.myForm.get(payload.id)?.setValue(payload.values);
    }

    this.checkFormValidity();
    //console.log('Form Value:', this.myForm.value);
  }
}
